import type { ReactNode } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '../ui';
import styles from './AppShell.module.scss';

/**
 * Bannière « Nouvelle version ».
 *
 * L'application ne se recharge jamais toute seule : une mise à jour appliquée pendant
 * qu'un membre saisit une note, en pleine séance, lui ferait perdre sa saisie. Le
 * rechargement est donc un geste explicite.
 */
export function UpdateBanner(): ReactNode {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className={styles.updateBanner} role="status">
      <span>Une nouvelle version du carnet est prête.</span>
      <Button onClick={() => void updateServiceWorker(true)}>Recharger</Button>
      <Button variant="ghost" onClick={() => setNeedRefresh(false)}>
        Plus tard
      </Button>
    </div>
  );
}
